export const DEFAULT_ADDRESS_OPTION = '1';
export const DIFFERENT_ADDRESS_OPTION = '2';
export const MANUAL_ADDRESS_OPTION = '3';
export const UPDATE = 'update';
export const RESET = 'reset';
export const RESET_ADDRESS = 'reset-address';
export const FOCUS = 'focus';
export const BLUR = 'blur';
export const START_ASYNC = 'start-async';
export const END_ASYNC = 'end-async';
export const emptyAddress = {
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  country: '',
  zip: ''
};
